// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useCurrentScenarioId } from '../../../../../state/hooks/ScenarioHooks';
import { useNiveauDePriorisation, useTwingraphQueriesStatus } from '../../../../../state/wizard/WizardHooks';

export const useNiveauDePriorisationTab = () => {
  const status = useTwingraphQueriesStatus();
  const scenarioId = useCurrentScenarioId();
  const niveauDePriorisation = useNiveauDePriorisation(scenarioId);
  const sortedNiveauDePriorisation = [...niveauDePriorisation].sort((a, b) =>
    a.Identifiant.localeCompare(b.Identifiant)
  );
  return { sortedNiveauDePriorisation, status };
};
